/* 
  javascript voor file input clear ('idd_clearfileinput')
  
  zetten op een button achter de file-<input>, zie onder
  
*/
function idd_clearfileinput(event) {
	event = event ? event : window.event;
	const target = event.target ? event.target : event.srcElement;
	
	var prev = target.previousSibling;
	
	//zoek de vorige element node (IE doet lastig)
	while (prev && prev.nodeType!=1) {
		prev = prev.previousSibling;
	}
	prev.value='';
	
	//in IE is het readonly...
	if (prev.value!='') { alert("Clearing does not function correctly in this browser,\\ntry erasing manually."); }
	
	return false;
}


function idd_onemoreattachment(inputname,inputsize,maxattachments) {
	var attachment = document.getElementById('attachments');
	var inputs = attachment.getElementsByTagName('input');
	
	var cnt = inputs.length/2;
	
	// niet teveel graag.
	if (cnt>=maxattachments) {
		//verwijder 'another attachment' knop
		const another = attachment.nextSibling;
		attachment.nextSibling.parentNode.removeChild(another);
	}
	
	var inp = document.createElement('input');
	
	inp.type = 'file';
	inp.size = inputsize;
	inp.name = inputname + '['+cnt+']';
	
	if (navigator.appName != "Microsoft Internet Explorer") {
		var clear = document.createElement('input');
		clear.type ='button';
		clear.value ='Clear';
		
		clear.addEventListener("click", idd_clearfileinput);
	}
	attachment.appendChild(inp);
	attachment.appendChild(document.createTextNode(' '));
	
	if (navigator.appName != "Microsoft Internet Explorer") {
		attachment.appendChild(clear);
	}
	attachment.appendChild(document.createElement('br'));
	
	return false;
}


/*

Makes a duplicate of a node and all its children
and puts them into a target node.

*/
function idd_cloneThisNode(cloneID,targetID) {
	var clone = document.getElementById(cloneID).cloneNode(true);
	var target = document.getElementById(targetID);
	
	//id moet eraf want anders ruzie
	clone.removeAttribute("id");
	
	target.appendChild(clone);
	
	return false;
}





//converteer 0x1f en de utf-8
function auto_beforeUseConverter(value, autocompleter) {
	return autocompleter.filterRecordSeparator(value);
}


//helper functie om altijd latin1/utf8 te doen op selected items en om de 0x1f-jes
// uit de waardes te filteren die uit [mod][ajax] komen bij gecombineerde kolommen
function auto_onItemSelect( callback, data, autocompleter) {
	data['value'] = autocompleter.filterRecordSeparator(data['value']);
	callback(data, autocompleter);
}



// Make sure that only if the value is the same as the last selected item, the hidden element has that id
function auto_focusOut(event) {
	var id = event.target.id.replace('id_','');
	var val = event.target.value;
	
	if (typeof auto_lastValue[id] === 'undefined' || (auto_lastValue[id] != '' && val != auto_lastValue[id])) {
		auto_lastValue[id] = '';
		
		$('#hidden_' + id).val('');
		
		// indicator en edit url grijs weergeven
		$('#origin_' + id).addClass('inactive');
		
		return true;
	}
	
	return false;
}


//laat zien dat je gekozen hebt voor een geldig item door er een groene dot achter te zetten
// en save de 'waarde' van de string door een eventueel hidden element op een waarde te zetten
function auto_selectItem(data, autocompleter) {
	var id = autocompleter.dom.$elem[0].id.replace('id_','');
	
	if (autocompleter.options.autoAddOriginURL) {
		auto_addOriginURL(data, autocompleter);
	}
	
	$('#hidden_' + id).val(data.data[0]);
	
	// indicator en edit url normaal weergeven
	$('#origin_' + id).removeClass('inactive');
	
	auto_lastValue[id] = autocompleter.dom.$elem[0].value;
}

// doet een url appenden achter het input field en de groene success indicator
// je kan daar naar het overzicht om item te editen
function auto_addOriginURL(data, autocompleter) {
	var id = autocompleter.dom.$elem[0].id.replace('id_', '');
	
	var htOriginSearch = idd_escapeHTML(autocompleter.options.originSearch);
	var htURL = idd_escapeHTML(autocompleter.options.url);
	var htArgValue = encodeURIComponent('="'+data.data[0]+'"');
	
	// update de URL en laat dan het span element met het a element zien
	$('#origin_' + id + ' a').attr('href', htURL + '?' + htOriginSearch + '=' + htArgValue);
	
	auto_lastValue[id] = autocompleter.dom.$elem[0].value;
}



function selectAll(checkboxSelector) {
	// This is a toggle, first find out wether we are going to select or deselect.
	if ($(checkboxSelector).length < 1) {
		return;
	}
	
	if ($(checkboxSelector + ":first")[0].checked) {
		$(checkboxSelector).each(function () {
			$(this).prop('checked',false);
		});
	} else {
		$(checkboxSelector).each(function () {
			$(this).prop('checked',true);
		});
	}
}


// attach onclick handlers, niet als global zodat boel niet vervuilt
function input_installHandlers() {
	$(document).ready( function() {
		$(".input_onemore").click(function() {
			var p = $(this).data('onemore');
			idd_onemoreattachment(p[0],p[1],p[2]);
		});
		
		$(".input_clear").click(function(event) {
			idd_clearfileinput(event);
		});
		
	});
}

// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
